import decorateBatchSummaryFromEvent from './decorateBatchSummaryFromEvent';

export default function dispatchBatchOperationFromEvent(
  dispatch,
  getState,
  event,
  upsertBatchFromEvent,
) {
  const decorated = decorateBatchSummaryFromEvent(event.data, getState());
  dispatch(upsertBatchFromEvent(decorated));
}
